import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ReferenceModel} from '../../shared/models/reference.model';
import {ReferencesService} from '../../shared/service/references.service';
import {GalleryGridItem} from '../../shared/models/gallery-grid-item';
import {fromEvent} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

@Component({
  selector: 'app-reference',
  templateUrl: './reference.component.html',
  styleUrls: ['./reference.component.scss']
})
export class ReferenceComponent implements OnInit {
  imageList = [];
  items: any[];
  sectionId: string;
  referenceId: string;

  selectedReference: ReferenceModel;
  galleryGridItems: GalleryGridItem[] = [];
  gridColumnCount: number;
  showFlag = false;
  selectedImageIndex = -1;
  galleryImageList: object[] = [];

  constructor(private route: ActivatedRoute,
              private referenceService: ReferencesService) {

    this.referenceId = this.route.snapshot.params['id'];
    this.sectionId = 'wedding';

    this.referenceService.getReference(this.referenceId).subscribe((response) => {
      this.selectedReference = response;

      this.initGalleries();
    });

    this.calculateGridColumnCount();

    fromEvent(window, 'resize')
      .pipe(debounceTime(100),
      )
      .subscribe(() => {
        this.calculateGridColumnCount();
      });

  }


  ngOnInit() {

  }

  initGalleries() {

    if (!this.selectedReference || !this.selectedReference.galleryImages || !this.selectedReference.galleryImages.length) {
      return;
    }

    for (const imageItem of this.selectedReference.galleryImages) {
      this.galleryGridItems.push({src: imageItem.imageUrl});
    }

    this.galleryImageList = this.galleryGridItems.map((item) => {
      return {
        image: item.src,
        thumbImage: item.src,
        alt: '',
        title: ''
      };
    });

  }

  gridElementClicked(index) {
    this.selectedImageIndex = index;
    this.showFlag = true;
  }


  closeEventHandler() {
    this.showFlag = false;
    this.selectedImageIndex = -1;
  }

  calculateGridColumnCount() {
    let colCount = 4;

    if (window.innerWidth < 640) {
      colCount = 2;
    } else if (window.innerWidth < 800) {
      colCount = 2;
    } else if (window.innerWidth < 1280) {
      colCount = 3;
    }

    this.gridColumnCount = colCount;
  }
}
